<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300">
      <v-card color="primary" outlined>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card outlined>
      <v-toolbar flat dense dark color="primary">
        <v-toolbar-title>IQC Lot Clone</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="
          var valueSend = [];
          sendToParentComponent(valueSend)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-text-field label="Source Of Manufacturing" v-model="receiveVar.source_of_mfg" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-text-field label="Reference Lot No." v-model="receiveVar.ref_lot_no" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu.menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="receiveVar.start_date" label="Start Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="receiveVar.start_date" @input="menu.menuStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-select :items="dropDownData.lis_iqc_level" v-model="receiveVar.level_cd" item-text="level_desc" item-value="level_cd" label="Level" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu.menuExpiredDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="receiveVar.expired_date" label="Expired Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="receiveVar.expired_date" @input="menu.menuExpiredDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-text-field label="Analyzer Desc" v-model="receiveVar.analyzer_desc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-text-field label="Analyzer Model" v-model="receiveVar.model_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-text-field label="Serial No" v-model="receiveVar.serial_no" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
    </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" class="mb-2" style="text-transform: capitalize"
          @click="
            var valueSend = [];
            valueSend.actionReturn = 'OK'
            sendToParentComponent(valueSend)">
        {{$t('ok')}}
        </v-btn>
        <v-divider class="mx-1" inset vertical></v-divider>
        <v-btn outlined color="primary" class="mb-2" style="text-transform: capitalize"
          @click="
            var valueSend = [];
            sendToParentComponent(valueSend)">
        {{$t('cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  export default {
    props: ['receiveVar'],
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        dialog: {
          dialogProgress: false,
        },
        menu: {
          menuStartDate: false,
          menuExpiredDate: false,
        },
        progressMessage: '',
        dropDownData: [],
      }
    },
    created: function () {
      this.retrieveDropDown()
    },
    computed: {
    },
    methods: {
      sendToParentComponent (value) {
        value.source_of_mfg = this.receiveVar.source_of_mfg
        value.browseName = this.receiveVar.browseName
        value.childSend = this.$options._componentTag
        this.$emit('eventReturn', value)
      },
      retrieveDropDown () {
        this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.dropDownData = response.data.data[0]
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      refresh () {
        this.menu.menuStartDate = true
      }
    }
  }
</script>